import { render, staticRenderFns } from "./commonTableScreening.vue?vue&type=template&id=6f048d48&"
import script from "./commonTableScreening.vue?vue&type=script&lang=js&"
export * from "./commonTableScreening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports